<script setup>
const refSearchbox = ref();
const props = defineProps([
  "input",
]);
const handleTextInput = (e) => {
  const input = e.target.value;
  EventBus.emit("searchSelect", input);
  // this.$emit("searchSelect", input);
  // if (refSearchbox.value) {
  //   refSearchbox.value.focus()
  // }
}
const clearInput = () => {
  // this.$emit("searchSelect", "");
  EventBus.emit("searchSelect", "");
}
const goToSearchResults = () => {
  EventBus.emit("goto-Search");
}
const offFocus = EventBus.on("focus-searchbox", () => {
  if (refSearchbox.value) {
    refSearchbox.value.focus()
  }
})

onBeforeUnmount(() => {
  offFocus()
})

</script>

<template>
  <div class="bg-white/90 py-4 mb-4 border-b border-gray-200 backdrop-blur">
    <div class="max-w-2xl mx-auto px-4">
      <h3 class="text-lg font-semibold text-center text-gray-900 mb-3 text-[18px]">{{ $t('products_looking_for') }}</h3>
      <div class="relative">
        <form class="flex items-center" @submit.prevent="goToSearchResults">
          <div class="flex-1 relative flex rounded-lg border border-gray-300 transition-all hover:border-[var(--color-primary)] hover:ring-2 hover:ring-[rgba(8,184,81,0.2)] focus-within:border-[var(--color-primary)] focus-within:ring-2 focus-within:ring-[rgba(8,184,81,0.2)]">
            <input 
              autofocus 
              ref="refSearchbox" 
              type="text" 
              class="cld-input rounded-r-none w-full border-0 focus:ring-0 focus:shadow-none" 
              :placeholder="$t('products_ready_in_warehouse')" 
              :value="input"
              @input="handleTextInput" 
            />
            <button 
              v-if="input && input.length > 1" 
              @click.prevent="clearInput" 
              type="button"
              class="absolute right-16 top-1/2 -translate-y-1/2 hidden md:inline-flex text-primary hover:text-primary/80"
              aria-label="Clear-Button"
            >
              <span class="text-sm font-semibold">×</span>
            </button>
            <button 
              class="cld-btn-primary bg-[#009d66] hover:bg-[#007a4d] rounded-l-none rounded-r-md px-5" 
              @click.prevent="goToSearchResults" 
              type="submit"
              aria-label="Search-Button"
            >
              <i class="fa fa-search"></i>
            </button>
          </div>
        </form>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* Tailwind utility classes used - minimal custom styles needed */
</style>
